import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export default function Nav({ cartCount = 0 }) {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.nav
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      className="fixed top-0 left-0 right-0 z-50 px-4 sm:px-8 py-3"
      data-testid="site-nav"
    >
      <div
        className={`mx-auto max-w-6xl flex items-center justify-between rounded-full px-4 sm:px-6 py-2.5 transition-[background-color,box-shadow,backdrop-filter] duration-300 ${
          scrolled ? "bg-white/70 backdrop-blur-xl shadow-[0_8px_30px_rgba(15,23,42,0.08)]" : "bg-transparent"
        }`}
      >
        <button onClick={() => scrollTo("hero")} data-testid="nav-logo" className="flex items-center gap-2">
          <img src="/assets/logo-cut.png" alt="ZoJu Juices" className="h-9 w-auto" />
        </button>
        <div className="hidden sm:flex items-center gap-7 text-sm font-medium text-ink/70">
          <button onClick={() => scrollTo("products")} className="hover:text-watermelon transition-colors" data-testid="nav-products">Juices</button>
          <button onClick={() => scrollTo("about")} className="hover:text-watermelon transition-colors" data-testid="nav-about">Zoey</button>
        </div>
        <button
          onClick={() => scrollTo("order")}
          data-testid="nav-order-btn"
          className="rounded-full bg-watermelon px-5 py-2.5 text-sm font-semibold text-white transition-transform duration-200 hover:scale-105 active:scale-95"
        >
          Order Now{cartCount > 0 ? ` · ${cartCount}` : ""}
        </button>
      </div>
    </motion.nav>
  );
}
